export function toggleFullScreen(character = "f") {
  /** @type any  */
  const elem = window.document.querySelector("html");
  /** @type any  */
  const document = window.document;

  if (
    elem &&
    !document.fullscreenElement &&
    //@ts-ignore
    !document.mozFullScreenElement &&
    //@ts-ignore
    !document.webkitFullscreenElement &&
    //@ts-ignore
    !document.msFullscreenElement
  ) {
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
      //@ts-ignore
    } else if (elem.msRequestFullscreen) {
      //@ts-ignore
      elem.msRequestFullscreen();
      //@ts-ignore
    } else if (elem.mozRequestFullScreen) {
      //@ts-ignore
      elem.mozRequestFullScreen();
      //@ts-ignore
    } else if (elem.webkitRequestFullscreen) {
      //@ts-ignore
      elem.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
    }
  } else {
    if (document.exitFullscreen) {
      document.exitFullscreen();
      //@ts-ignore
    } else if (document.msExitFullscreen) {
      //@ts-ignore
      document.msExitFullscreen();
      //@ts-ignore
    } else if (document.mozCancelFullScreen) {
      //@ts-ignore
      document.mozCancelFullScreen();
      //@ts-ignore
    } else if (document.webkitExitFullscreen) {
      //@ts-ignore
      document.webkitExitFullscreen();
    }
  }
}
